var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "confirm-button" },
    [
      _c(
        "el-popover",
        {
          ref: "confirmbutton",
          attrs: {
            placement: _vm.placement,
            disabled: _vm._popoverDisabled,
            "popper-class": "confirm-popover",
          },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          !!_vm.title
            ? _c("p", { staticStyle: { "font-size": "14px" } }, [
                _c("i", {
                  staticClass: "el-icon-info",
                  staticStyle: { color: "#ffbf00" },
                }),
                _c("span", { domProps: { textContent: _vm._s(_vm.title) } }),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "confirm-button-context" },
            [_vm._t("context")],
            2
          ),
          _c(
            "div",
            { staticClass: "confirm-button-btn-group" },
            [
              _c("el-button", {
                attrs: { size: "mini", type: "text" },
                domProps: { textContent: _vm._s(_vm.cancelText) },
                on: { click: _vm._cancel },
              }),
              _c("el-button", {
                staticStyle: { "margin-left": "20px" },
                attrs: { size: "mini", type: "primary" },
                domProps: { textContent: _vm._s(_vm.okText) },
                on: { click: _vm._confirm },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-button",
        {
          directives: [
            {
              name: "popover",
              rawName: "v-popover:confirmbutton",
              arg: "confirmbutton",
            },
          ],
          attrs: { type: _vm.type, size: _vm.size, disabled: _vm.disabled },
          on: { click: _vm._click },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }